
import { locale } from './globals.js';
import { loadJSON, throttle, truncateString } from './toolbox.js';
import { init as initCarousel } from './image-carousel.js';
import { init as initVideo } from './video-handler.js';

const defaultApi = '/assets/data/instagram.json';

const postPopup = function (post) {
  // ${post.caption ? (postPopupCaption(post)) : ''}
  let imgOnly = (post.caption == null) ? 'image-only' : '';
  if (post.caption == null) {

  }
  return `
    <div class="popup-box social-media-post" data-type="${post.postType}" data-source="${post.source}">
      <div class="wrap">
        ${post.media ? (postPopupHeader(post)) : ''}
        ${postPopupCaption(post)}
      </div>
    </div>
    `
}
const postPopupCaption = function (post) {
  return `
    <div class="popup-content post-content">
      <a href="${post.postUrl}" target="_blank" class="post-header">
        <div class="account-id">@zayedsportscity</div>
        <div class="source-icon"><i class="icon fab fa-${post.source}"></i></div>
      </a>
      <p>
        ${(post.caption) ? post.caption : ''}
      </p>
    </div>
  `
}
const postPopupHeader = function (post) {
  let media = [];
  post.media.forEach((item) => {
    if (item.mediaType === 'image') {
      media.push(`
        <figure class="cover aspect-ratio square" style="background-image: url('${item.mediaUrl}')">
          <img src="${item.mediaUrl}" alt="">
        </figure>
      `)
    } else if (item.mediaType === 'video') {
      media.push(`
        <figure class="cover aspect-ratio square video-wrap" style="" data-video-handler>
          <video playsinline preload="none" poster="${item.mediaPoster}">
            <source src="${item.mediaUrl}" type="video/mp4">
          </video>
        </figure>
      `)
    }
  })
  return `
    <div class="popup-header image-carousel" data-image-carousel>
      ${media.join(' ')}
    </div>
  `
}
const postElem = function (post, index) {
  let item = document.createElement('div');
  item.classList.add('post-item');
  let thumb = (post.postType == 'text') ? postThumbText(post, index) : postThumbImage(post, index);
  item.innerHTML = `
    ${thumb}
    <a href="${post.postUrl}" target="_blank" class="post-link">
      <i class="icon fab fa-${post.source}"></i> <span class="name">@zayedsportscity</span>
    </a>`
  return item;
}
const postThumbImage = function (post, index) {
  let caption = '';
  if (post.caption) caption = `<div class="post-caption"><span class="copy">${truncateString(post.caption, 100)}</span></div>`;
  return `
    <a class="post-thumb box" href="#" id="post_${index}" data-index="${index}" data-type="image" data-source="${post.source}">
      <figure class="cover aspect-ratio square hover-zoom" style="background-image:url('${post.thumbnailUrl}')"></figure>
      ${caption}
    </a>`
}
const postThumbText = function (post, index) {
  return `
    <a class="post-thumb box" href="#" id="post_${index}" data-index="${index}" data-type="text" data-source="${post.source}">
      <div class="box-content"><p>${post.caption}</p></div>
    </a>`
}

class SocialMediaThumbs {
  constructor (el) {
    if(!el) return false;
    this.el = el;
    this.api = this.el.getAttribute('data-api') ? this.el.getAttribute('data-api') : defaultApi;
    this.rowLength = parseInt(window.getComputedStyle( this.el, ':before').getPropertyValue('content').split('"')[1]);
    this.expandIndex = 1;
    this.batch = this.rowLength * 2;
    this.list = this.el.querySelector('[data-post-list]');
    this.expandButton = this.el.querySelector('[data-post-list-expand]');
    if(this.expandButton) {
      this.expandButton.addEventListener('click', () => {
        this.expandIndex += 1;
        this.updateList();
      });
    }
    loadJSON(this.api, (data) => {
      this.data = JSON.parse(data);
      requestAnimationFrame(() => {
        this.createThumbs();
        this.createPopups();
        this.updateList();
      })
    }, (resp) => {});
  }
  createThumbs() {
    this.thumbs = [];
    this.data.forEach((post, index) => {
      this.thumbs.push(postElem(post, index));
    })
  }
  updateList() {
    this.rowLength = parseInt(window.getComputedStyle( this.el, ':before').getPropertyValue('content').split('"')[1]);
    this.batch = this.rowLength * 2 * this.expandIndex;

    let newList = this.list.cloneNode(true);
    newList.innerHTML = '';
    this.thumbs.forEach((post, index) => {
      if (index < this.batch) {
        newList.appendChild(post);
      }
    })
    requestAnimationFrame(() => {
      this.list.parentNode.replaceChild(newList, this.list);
      this.list = newList;
      if(this.list.children.length >= this.thumbs.length) {
        this.expandButton.setAttribute('disabled', 'disabled');
      }
      requestAnimationFrame(() => {
        //this.prepPopups();
      });
    })
  }
  createPopups() {
    let thumbItems = Array.from(this.list.querySelectorAll('.post-thumb'));
    this.popups = [];
    this.thumbs.forEach((thumb, index) => {
      this.popups.push({content: postPopup(this.data[index])});
      let t = thumb.querySelector('.post-thumb');
      t.addEventListener('click', (event) => {
        event.preventDefault();
        this.thumbClicked(thumb, index);
      })
    })
  }
  thumbClicked(thumb, index) {
    this.openPopups(index)
  }
  openPopups(index) {
    let fancyOptions = {
      type: 'html',
      baseClass: 'event-popup content-view',
      idleTime: false,
      video: { autoStart: false },
      afterShow: this.initPopupContents
    }
    $.fancybox.open(this.popups, fancyOptions, index);
  }
  initPopupContents (instance, current) {
    let carousel = current.$content[0].querySelector('[data-image-carousel]');
    let videos = Array.from(current.$content[0].querySelectorAll('[data-video-handler]'));
    initCarousel(carousel);
    if (videos && videos.length > 0) {
      videos.forEach((video) => {
        initVideo(video);
      })
    }
  }

  
}
export default function () {
  new SocialMediaThumbs(document.querySelector('[data-social-media-thumbs]'));
}
